import { ComponentStyleConfig } from "@chakra-ui/react";
import { mode } from "@chakra-ui/theme-tools";

const solid = (props) => ({
  bgColor: "#00A28D",
  color: "white",
  border: "1px solid #00A28D",
  _hover: {
    bgColor: "#00927f",
    border: "1px solid #00927f",
    _disabled: {
      bgColor: "neutral.200",
      borderColor: "neutral.200",
    },
  },
  _focus: {
    bgColor: "#00927f",
    border: "1px solid #00927f",
  },
  _disabled: {
    bgColor: "neutral.200",
    borderColor: "neutral.200",
    color: mode("white", "neutral.600")(props),
    cursor: "not-allowed",
    opacity: 1,
  },
});

export const Button: ComponentStyleConfig = {
  baseStyle: (props) => ({
    fontWeight: "medium",
    fontSize: "12px",
    borderRadius: "8px",
    color: "white",
    border: "none",
    px: "10px",
    py: "10px",
    paddingInline: "10px",
    height: "auto",
    textTransform: "none",
    _focus: {
      boxShadow: "none",
    },
    _focusVisible: {
      boxShadow: "none",
    },
  }),
  variants: {
    outline: {
      bgColor: "rgba(255, 255, 255, 0.05)",
      color: "#777E90",
      border: "1px solid #DEDEE0",
      filter: "drop-shadow(0px 0px 50px rgba(0, 0, 0, 0.05))",
      _hover: {
        bgColor: "rgb(224, 244, 242, 0.1)",
        _disabled: {
          bgColor: "transparent",
          borderColor: "transparent",
        },
      },
      _focus: {
        bgColor: "rgb(224, 244, 242, 0.1)",
      },
      _disabled: {
        bgColor: "transparent",
        borderColor: "transparent",
        cursor: "not-allowed",
      },
      _dark: {
        color: "#DEDEE0",
        bgColor: "rgba(255, 255, 255, 0.05)",
        boxShadow: "0px 0px 50px rgba(0, 0, 0, 0.05)",
      },
    },
    solid: (props) => ({
      ...solid(props),
      border: "0px",
    }),
    ghost: {
      height: "auto",
      bgColor: "transparent",
      color: "primary.300",
      border: "none",
      p: 1,
      _hover: {
        color: "primary.700",
        bgColor: "transparent",
        _disabled: {
          bgColor: "transparent",
          borderColor: "transparent",
        },
      },
      _focus: {
        color: "primary.700",
        bgColor: "transparent",
      },
      _active: {
        color: "primary.700",
        bgColor: "transparent",
      },
      _disabled: {
        color: "neutral.600",
        bgColor: "transparent",
        borderColor: "transparent",
        cursor: "not-allowed",
      },
    },
    dark: {
      bgColor: "rgba(255, 255, 255, 0.05)",
      color: "white",
      _hover: {
        bgColor: "rgb(224, 244, 242, 0.1)",
        _disabled: {
          bgColor: "neutral.200",
          borderColor: "neutral.200",
        },
      },
      _focus: {
        bgColor: "rgb(224, 244, 242, 0.1)",
      },
      _disabled: {
        bgColor: "neutral.200",
        borderColor: "neutral.200",
        color: "neutral.600",
        cursor: "not-allowed",
        opacity: 1,
      },
    },
    error: {
      bgColor: "transparent",
      border: "1px solid",
      borderColor: "error",
      color: "error",
      _hover: {
        bgColor: "rgb(224, 244, 242, 0.1)",
        _disabled: {
          bgColor: "transparent",
          borderColor: "transparent",
        },
      },
      _focus: {
        bgColor: "rgb(224, 244, 242, 0.1)",
      },
      _disabled: {
        bgColor: "transparent",
        borderColor: "transparent",
        cursor: "not-allowed",
      },
    },
    gradient: (props) => ({
      color: "#444444",
      bg: "linear-gradient(155deg, #9CF9FF 0%, #00C2FF 100%)",
      _hover: {
        bg: "linear-gradient(155deg, #9CF9FF 0%, #00C2FF 100%)",
        _disabled: {
          bg: "linear-gradient(155deg, #9CF9FF 0%, #00C2FF 100%)",
        },
      },
    }),
    symbol: (props) => ({
      ...solid(props),
      fontSize: "1.5rem",
      color: "#FFFFFF",
      borderRadius: "md",
      bgColor: "#146588!important",
      _disabled: {
        cursor: "not-allowed",
        border: "0",
      },
      border: 0,
    }),
  },
  sizes: {
    sm: {
      h: "auto",
    },
    md: {
      h: "auto",
    },
    symbol: {
      width: "1.75rem",
      height: "1.75rem",
    },
  },
  defaultProps: {
    variant: "solid",
  },
};

export default Button;
